import {
  FactsStructureType_insuranceHandbookPageCollection_items,
  FactsStructureType_insuranceHandbookPageCollection_items_childrenPagesCollection_items,
} from "globalQueries/contentfulTypes/FactsStructureType";

export const GetTopLevelItems = (
  array: Array<FactsStructureType_insuranceHandbookPageCollection_items>,
): Array<FactsStructureType_insuranceHandbookPageCollection_items_childrenPagesCollection_items> => {
  const topLevelStartNode = array.find(
    (item: FactsStructureType_insuranceHandbookPageCollection_items) =>
      item?.slug === "forsakringshandbok-start",
  );
  const topLevelItems = topLevelStartNode?.childrenPagesCollection?.items;
  return topLevelItems;
};
